export default function toPercent(num) {
  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  return (num * 100).toFixed(digits) + "%";
}